import commonFn from '@/common/common-fn'
import enumeration from '@/common/enumeration'
import notify from '@/utils/notify'
import messageBox from '@/utils/message-box'
import { localStorage } from '@/utils/storage'
import idb from '@/utils/idb'
import { readonly, App } from 'vue'

export interface AppGlobalProps {
  $commonFn: typeof commonFn;
  $localStorage: typeof localStorage;
  $idb: typeof idb;
  $enumeration: Record<string, any>;
  $notify: typeof notify;
  $messageBox: typeof messageBox;
}

export default {
  install: (app: App) => {
    app.config.globalProperties.$commonFn = commonFn
    app.provide('$commonFn', readonly(commonFn))
    app.config.globalProperties.$localStorage = localStorage
    app.provide('$localStorage', readonly(localStorage))
    app.config.globalProperties.$idb = idb
    app.provide('$idb', readonly(idb))
    app.config.globalProperties.$enumeration = enumeration
    app.provide('$enumeration', readonly(enumeration))
    app.config.globalProperties.$notify = notify
    app.provide('$notify', readonly(notify))
    app.config.globalProperties.$message = messageBox
    app.provide('$messageBox', readonly(messageBox))
  }
}
